//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import fieldMetaData from '../../graphql/schema/fieldMetaData';
import Formatters from '../../components/grid-addons/formatters';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { ImportedPixSellOrder } from '../../graphql/entities';
import { Direction, IImportedPixSellOrder } from '../../graphql/schema/p4types';
import { Paths } from '../../@types/keyOfNested';

const IMPORTED_PIX_SELL_FIELD_NAMES: Array<Paths<IImportedPixSellOrder>> = [
  'createdAt',
  'pixSellConfiguration.name',
  'orderReference',
  'salesOrder.orderNumber',
  'orderImportFailureReason',
  'failureDescription',
  'resolved',
];

const IMPORTED_PIX_SELL_COLUMN_OVERRIDES = {
  orderImportFailureReason: {
    options: fieldMetaData.OrderImportFailureReason,
    formatter: Formatters.EnumFormatter,
  },
};

const ImportedPixSellOrderWorkspace = (props) => {
  const workspaceProps = useWorkspace<IImportedPixSellOrder>(props, ImportedPixSellOrder, {
    columns: IMPORTED_PIX_SELL_FIELD_NAMES,
    columnOverrides: IMPORTED_PIX_SELL_COLUMN_OVERRIDES,
    initialSortColumn: 'createdAt',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={ImportedPixSellOrder.type}
      title={ImportedPixSellOrder.title}
      formUrl={ImportedPixSellOrder.formUrl}
      defaultQuery={ImportedPixSellOrder.workspace}
      entity={ImportedPixSellOrder}
      permittedOperations={ImportedPixSellOrder.operations}
      {...workspaceProps}
      {...props}
    />
  );
};

export default ImportedPixSellOrderWorkspace;
